import { SET_LOCATIONS } from './loyaltyLocationsActions';
import type { LoyaltyLocationsAction } from './loyaltyLocationsActions';
import type { StoreLocation } from '../../../components/loyalty/data/types';

export interface LoyaltyLocationsState {
  locations: StoreLocation[];
}

const initialState: LoyaltyLocationsState = {
  locations: [],
};

export default function loyaltyLocationsReducer(
  state = initialState,
  action: LoyaltyLocationsAction,
): LoyaltyLocationsState {
  switch (action.type) {
    case SET_LOCATIONS:
      return { ...state, locations: action.payload };
    default:
      return state;
  }
}
